export default function searchKeyEqualToValueInObject ({ keyToSearch, equalsToValue, objectToSearch }, result = []) {
  try {
    if (typeof objectToSearch !== 'object') {
      throw new Error('objectToSearch must be an object.')
    }

    Object.keys(objectToSearch).forEach((key) => {
      if (objectToSearch[key] && typeof objectToSearch[key] === 'object') {
        if (Object.prototype.hasOwnProperty.call(objectToSearch[key], keyToSearch)) {
          const keyToSearchEqualsToValue = objectToSearch[key][keyToSearch] === equalsToValue
          keyToSearchEqualsToValue && result.push(objectToSearch[key])
        }

        searchKeyEqualToValueInObject({
          keyToSearch,
          equalsToValue,
          objectToSearch: objectToSearch[key]
        }, result)
      }
    })

    return result
  } catch (error) {
    console.error(error)
    return []
  }
}
